/* eslint-disable react/prop-types */
/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import FlipMove from 'react-flip-move';

import classes from './Actions.css';
import Aux from '../../hoc/Aux';
import ActionsItems from './ActionsItem/ActionsItem';

const actions = (props) => {
  const ActionsToDisplay = props.events.map(action => {
    let txtAction = '';
    let icAction = '';

    console.log(action);
    if (props.language === 'EN-en') {
      if (action.kindOfVote === 'positive') {
        txtAction = `${action.user.name} likes ${action.song.name}`;
        icAction = 'ic_like.svg';
      } else if (action.kindOfVote === 'negative') {
        txtAction = `${action.user.name} doesn't like ${action.song.name}`;
        icAction = 'ic_dislike.svg';
      } else if (action.kindOfVote === 'new') {
        txtAction = `${action.user.name} proposed ${action.song.name}`;
        icAction = 'ic_plus.svg';
      } else if (action.kindOfVote === 'onAir') {
        txtAction = `${action.song.name} is now online!`;
        icAction = 'ic_play.svg';
      } else if (action.kindOfVote === 'keep') {
        txtAction = `${action.user.name} keeps ${action.song.name}`;
        icAction = 'ss.svg';
      } else if (action.kindOfVote === 'skip') {
        txtAction = `${action.user.name} skips ${action.song.name}`;
        icAction = 'ss.svg';
      }
      // } else if (action.kindOfVote === 'songDeleted') {
      //   txtAction = `${action.song.name} pufff, deleted.`;
      //   icAction = 'ss.svg';
      // }
    } else if (props.language === 'IT-it') {
      if (action.kindOfVote === 'positive') {
        txtAction = `A ${action.user.name} piace ${action.song.name}`;
        icAction = 'ic_like.svg';
      } else if (action.kindOfVote === 'negative') {
        txtAction = `A ${action.user.name} non piace ${action.song.name}`;
        icAction = 'ic_dislike.svg';
      } else if (action.kindOfVote === 'new') {
        txtAction = `${action.user.name} ha proposto ${action.song.name}`;
        icAction = 'ic_plus.svg';
      } else if (action.kindOfVote === 'onAir') {
        txtAction = `${action.song.name} è in riproduzione!`;
        icAction = 'ic_play.svg';
      } else if (action.kindOfVote === 'keep') {
        txtAction = `${action.user.name} vuole tenere ${action.song.name}`;
        icAction = 'ss.svg';
      } else if (action.kindOfVote === 'skip') {
        txtAction = `${action.user.name} vuole saltare ${action.song.name}`;
        icAction = 'ss.svg';
      }
      // } else if (action.kindOfVote === 'songDeleted') {
      //   txtAction = `${action.song.name} pufff, eliminata`;
      //   icAction = 'ss.svg';
      // }
    }

    return (
      <ActionsItems
        icAction={icAction}
        action={txtAction} 
        pictureUser={action.user.picture}
        key={action.id}
      />
    ); 
  });

  return (    
    <Aux>
      <h4 className={classes.Title}>{props.eventTitle}</h4>
      <hr />
      <div className={classes.ActionColumn}>
        <FlipMove
          enterAnimation="fade" 
          leaveAnimation="fade"
          duration="200"
        >
          {
              ActionsToDisplay
          }
        </FlipMove>
      </div>
    </Aux>
  );
};

export default actions;
